// Import Firebase modules
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBt1pEN1-LWBgeXXQKo2xnY3eIXdBxzHyIw",
  authDomain: "care-fc7fd.firebaseapp.com",
  projectId: "care-fc7fd",
  storageBucket: "care-fc7fd.appspot.com",
  messagingSenderId: "916964134329",
  appId: "1:916964134329:web:8abe947b32069b93813a68",
  measurementId: "G-PLES9THTKG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
